var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("b-skeleton-wrapper", {
        attrs: { loading: _vm.isBusy },
        scopedSlots: _vm._u([
          {
            key: "loading",
            fn: function() {
              return [
                _c(
                  "b-card",
                  [
                    _c("b-skeleton", { attrs: { width: "85%" } }),
                    _vm._v(" "),
                    _c("b-skeleton", { attrs: { width: "55%" } }),
                    _vm._v(" "),
                    _c("b-skeleton", { attrs: { width: "70%" } })
                  ],
                  1
                )
              ]
            },
            proxy: true
          }
        ])
      }),
      _vm._v(" "),
      !_vm.isBusy
        ? _c(
            "div",
            [
              _vm.user && _vm.user.name
                ? _c(
                    "b-card",
                    { staticClass: "border-0" },
                    [
                      _c("b-card-title", [
                        _c(
                          "div",
                          { staticClass: "d-flex align-items-center" },
                          [
                            _c("portal-target", {
                              staticClass: "d-flex align-items-center mt-1",
                              attrs: { name: "sidebar-toggle" }
                            }),
                            _vm._v(
                              "\n          Добро пожаловать, " +
                                _vm._s(_vm.user.name) +
                                "!\n        "
                            )
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("b-card-text", [
                        _vm._v(
                          "\n        Логин: " + _vm._s(_vm.user.username) + " "
                        ),
                        _c("br"),
                        _vm._v(
                          "\n        Роль: " + _vm._s(_vm.user.role_name) + " "
                        ),
                        _c("br"),
                        _vm._v(
                          "\n        Email: " +
                            _vm._s(_vm.user.email) +
                            "\n      "
                        )
                      ])
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-15737ea2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// /home/el/code/sverkasoft-erp/frontend/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15737ea2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!/home/el/code/sverkasoft-erp/frontend/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Home.vue
// module id = null
// module chunks = 